
import {message, urlValidation} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import {scrapPublication} from '@/libs/api/api'
import SearchDropdown from '@/components/component/admin/SearchDropdown/SearchDropdown.vue'


import {isEmpty} from 'lodash'
export default {
  name: 'AddNewCategory',
  components: {SearchDropdown},
  props: {
    module: {
        type: String,
        default: 'AUTHOR'
    },
    buttonAction: {
      type: Function
    }
  },
  data () {
    return {
      isEmpty,
      formData: {
          id: '',
          url: ''
      },
      author: {},
      publisher: {},
      isPublisher: false,
      isPublisherConfirmed: true,
      urlChecked: false,
      idChecked: false,
      publisherChecked: false,
      idConfirmed: true,
      urlConfirmed: true,
      isFinal: false,
      isConfirm: false,
      step: 1,
      skip: 0,
      isProgress: false
    }
  },
  methods: {
    validateID (rule, value, callback) {
      if (this.idChecked) {
        if (isEmpty(value)) callback(new Error('Field should not be empty'))
        if (!value.match(/^[0-9a-z]+$/)) callback(new Error('Invalid characters'))
        else callback()
      } else callback() 
    },
    validateURL (rule, value, callback) {
      if (this.urlChecked) {
        if (isEmpty(value)) callback(new Error('Field should not be empty'))  
        if (value.includes('http')) callback(new Error('Try adding url without web protocols(http or https)'))
        if ((!value.includes('http') && !urlValidation('https://' + value))) callback(new Error('Incorrect url'))
        else callback()
      } else callback()      
    },
    isDisabled (type) {
      switch (type) {
        case 'next':
          if (this.urlChecked) return false
          return true
        case 'confirm':
          if (this.isConfirmedTaxonomy === true) return false
          return true
      }
    },
    button: async function (type, formName) {
      switch (type) {
        case 'back':
          this.step = 1
          this.isConfirm = false
          break
        case 'next':
          this.$refs[formName].validate(valid => {
            if (!valid) return
            this.step = 2
            this.isConfirm = true
          })
          break
        case 'confirm':
            this.scrapData()
          break
      }
    },
    scrapData: async function () {
      try {
        let body =  await this.getBody()
      if (isEmpty(body)) {
        message(this, constants.messageType.ERROR, "No field selected")
      }
      this.isProgress = true
      this.skip = 15
      await scrapPublication(this.module.toLowerCase(), body)
      this.skip = 100
      this.isProgress = false
      this.step = 3
      this.isFinal = true
      } catch (error) {
        this.isProgress = false
        message(this, constants.messageType.ERROR, error.message)
        console.error(error)
      }
    },
    handleSearch (type, item) {
        if (type === "PUBLISHER") {
          this.publisher = item
        } else {
          this.author = item
        }
        
    },
    getBody () {
      let body = {}
      if (this.urlChecked && this.urlConfirmed && this.formData.url !== '') {
        body.url = `https://${this.formData.url}`
      }
      if (this.idChecked && this.idConfirmed && !isEmpty(this.author)) {
        body.author = this.author._id
      }
      if (this.isPublisher && this.isPublisherConfirmed && !isEmpty(this.publisher)) {
        body.publisher = this.publisher._id
      }
      return body
    }
  }
}
